import gql from 'graphql-tag'
import richTextFragment from '@components/renderers/rich-text.fragment'
import richTextFragmentCut from '@components/renderers/rich-text.fragment-cut'

const QUERY = gql`
query AssociateProgram($preview: Boolean, $category: String) {
  associateProgramCollection(limit: 1, preview: $preview, where: {pageSlug: "/associate-program"}) {
    items {
      faq {
        headline
        itemsCollection(limit: 8, where: {category: $category}) {
          items {
            summary
            details
            id
            text {
              ${richTextFragment}
            }
            linksCollection(limit: 3) {
              items {
                ctaText
                ctaLink
              }
            }
          }
        }
      }
    }
  }
}
`

const CUSTOM_PAGE_FAQ_QUERY = gql`
  query CustomPage($slug: String, $heading: String, $category: String) {
    customPageCollection(limit: 1, where: {slug: $slug}) {
      items {
        contentSectionsCollection(limit: 1, where: {heading: $heading}) {
          items {
            __typename
            ... on Accordion {
              headline
              itemsCollection(limit: 8, where: {category: $category}) {
                items {
                  summary
                  details
                  id
                  text {
                    ${richTextFragmentCut}
                  }
                  linksCollection(limit: 3) {
                    items {
                      ctaText
                      ctaLink
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export { CUSTOM_PAGE_FAQ_QUERY }
export default QUERY
